import { useState, useCallback } from 'react';
import { geographicPoint } from '../constants';
export const usePropertyPopup = (mapView, point) => {
    const [stateFocused, setFocused] = useState(null);
    const clearFocused = useCallback(() => {
        setFocused(null);
    }, []);
    const showPopup = useCallback((x, jump) => {
        var _a, _b, _c;
        if (!mapView)
            return;
        if (jump === true) {
            showPopup(x, {});
        }
        else if (jump) {
            mapView.goTo({
                'center': (_a = jump.center) !== null && _a !== void 0 ? _a : point(x),
                'zoom': Math.max(mapView.zoom, (_b = jump.zoom) !== null && _b !== void 0 ? _b : 17),
            }, { 'duration': (_c = jump.duration) !== null && _c !== void 0 ? _c : 500 }).then(() => {
                showPopup(x);
            }).catch(() => { });
        }
        else {
            const [lon, lat] = point(x);
            const screenPoint = mapView.toScreen(geographicPoint(lon, lat));
            if (screenPoint) {
                setFocused(Object.assign(Object.assign({}, x), { screenX: screenPoint.x + 20, screenY: screenPoint.y - 20 }));
            }
        }
    }, [mapView]);
    return { stateFocused, clearFocused, showPopup };
};
